import preferredTimeController from './controllers/preferred.time.controller';
import staffPickerController from './controllers/staffPicker.controller';

import preferredTimeComponent from './components/preferred.time.component';
import staffPickerComponent from './components/staffPicker.component';

import availabilityService from './services/availability.service';
import availabilityCacheService from './services/availability.cache.service';
import startTimeService from './services/startTime.service';
import quantityService from './services/quantity.service';
import suggestionsService from './services/suggestions.service';

let sharedAvailabilityModule = angular.module('spabooker.shared.availability', [])
    .component('preferredTime', preferredTimeComponent)
    .component('staffPicker', staffPickerComponent)

    .controller('preferredTimeController', preferredTimeController)
    .controller('staffPickerController', staffPickerController)

    .factory('availabilityService', availabilityService)
    .factory('availabilityCacheService', availabilityCacheService)
    .factory('startTimeService', startTimeService)
    .factory('quantityService', quantityService)
    .factory('suggestionsService', suggestionsService)
    ;

export default sharedAvailabilityModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/index.js